import { Component, Input, OnInit } from '@angular/core'
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router'
import { OrderService } from 'src/app/services/order.service'
import { ShippingService } from 'src/app/services/shipping.service'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'gw-chkout-layout',
    templateUrl: './checkout.layout.component.html',
    styleUrls: ['./checkout.layout.component.scss'],
    standalone: false
})

export class CheckoutLayoutComponent implements OnInit {
  @Input() steps: string[]
  
  protected readonly trustpilot = environment.tags ? environment.tags.trustpilot : null
  protected readonly isRMPhotoEnv = environment?.source?.type === 'photo'
  protected readonly isRMP = environment.source.domain === 'rmp'
  public data
  public submitting = false
  public isPickupOptSelected: boolean = undefined

  constructor(
    private router: Router,
    private activated_route: ActivatedRoute,
    private orderService: OrderService,
    private shippingService: ShippingService
  ) { }

  ngOnInit() {
    this.initiateRoute()
    this.listenForProductChanges()
    this.addRMPSAScript()
  }

  private addRMPSAScript() {
    // Shopper Approved
    if (environment.source.domain === 'rmp') {
      let sa_script = document.createElement('script')
      sa_script.type = 'text/javascript'
      sa_script.innerText = `
        var sa_interval = 5000;
        function saLoadScript(src) { 
          var js = window.document.createElement('script'); 
          js.src = src; 
          js.type = 'text/javascript'; 
          document.getElementsByTagName("head")[0].appendChild(js); 
        } 

        if (typeof(shopper_first) == 'undefined') saLoadScript('https://www.shopperapproved.com/widgets/8693/merchant/rotating-widget/b90Dbhnjw6fk.js?v=8');
      `
      document.body.appendChild(sa_script)
    }
  }

  initiateRoute(): void {
    this.getRouterData()

    this.router.events
      .subscribe((event) => {
        if (event instanceof RoutesRecognized) {
          let route = event.state.root
          while (route.firstChild) {
           route = route.firstChild
          }

          this.data = route.data
        }
      })
  }

  private listenForProductChanges(): void {
    this.orderService.isPickupOptSelected$.subscribe(isSelected => {
      this.isPickupOptSelected = this.isRMPhotoEnv && isSelected
    })
  }

  getRouterData(): any {
    while (this.activated_route.firstChild) {
      this.activated_route = this.activated_route.firstChild
    }

    this.data = this.activated_route.snapshot.data
  }

  showSummary(): boolean {
    return this.data?.step === 2 || this.data?.step === 3
  }

  get headline(): string {
    return this.isRMPhotoEnv && this.isPickupOptSelected && this.data?.step === 3 ? this.data?.pickup?.headline : this.data?.headline
  }

  get description(): string {
    return this.isRMPhotoEnv && this.isPickupOptSelected && this.data?.step === 3 ? this.data?.pickup?.description : this.data?.description
  }

  public getPreviousStep(): string {
    if (this.data?.step === 3) {
      return this.shippingService.shipping_required() ? '/step-3' : '/step-2'
    } else {
      return this.data?.previous
    }
  }

}
